module.exports = __webpack_public_path__ + "vomit.605de052.png";